import { cloneElement, ReactElement, useEffect, useRef } from 'react';

interface Props {
  children: ReactElement;
  otherInsides?: string[];
  onClickOutside: () => void;
}

const ClickOutside = ({ children, otherInsides, onClickOutside }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target;
      if (ref.current && target instanceof HTMLElement) {
        let inside = false;

        if (ref.current?.contains(target)) {
          inside = true;
        }

        otherInsides?.forEach((selector) => {
          document.querySelectorAll(selector).forEach((element) => {
            if (element.contains(target)) {
              inside = true;
            }
          });
        });

        if (!inside) {
          onClickOutside();
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return cloneElement(children, { ref });
};

export default ClickOutside;
